import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, InputLabel, MenuItem, Select, Table, TableHead, TableCell, TableBody, TableRow, Typography, TextField } from '@mui/material';
import { Grid, Paper } from '@mui/material';


import PageTitle from '../ui/PageTitle';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import AppBindStyles from '../../AppBindStyles';

import FeatureFlagCreateMutation from './FeatureFlagCreateMutation';
import FeatureFlagDeleteMutation from './FeatureFlagDeleteMutation';

const abEnvironment = new AbEnvironment();

const FeatureFlagManageQuery = graphql`
query FeatureFlagManageQuery ($accountId: UUID) {
  query { 
    base : allAccountFeatureTs (condition: { accountId: null}  orderBy: FLAG_NAME_ASC) {
    	nodes { 
      	accountFeatureId
      	flagName 
      	flagValue 
      	flagType 
      	flagDescription 
      	flagValueTxt 
    	}
  	}
    account: allAccountFeatureTs (condition: { accountId: $accountId}  orderBy: FLAG_NAME_ASC) {
    	nodes { 
      	accountFeatureId
      	flagName 
      	flagValue 
      	flagType 
      	flagDescription 
      	flagValueTxt 
    	}
  	}
	}
  allAccountTs (condition: { accountId: $accountId}) {
    nodes {
      accountName
    }
  }

}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    // width: 200
  },
  radio: {
    marginTop: 16
  },
  formControl: {
    marginTop: '24',
  },
  select: {
    marginRight: theme.spacing(1),
    marginTop: 0,
    marginLeft: 0,
    width: 200,
  },
});

class FeatureFlagManage extends Component {
  state = {
    flagName: '',
    flagValue: '',
    flagValueTxt: '',
    settingName: '',
    settingValue: '',
    settingValueTxt: '',
    forceFetch: 0
  };


  handleFlagNameChange(event, flagType) {

    let flagName =  event.target.value;
    let flagValue = 0;
    for (let i = 0; i < flagType.length; i++) {
      let feature = flagType[i];
      if (feature.flagName === flagName) {
        flagValue = feature.flagValue;

      }
    }  

    this.setState({flagName: event.target.value, flagValue: flagValue});
  };


  handleDefaultFlagNameChange(event, accountSettingType) {
    let settingName =  event.target.value;
    let settingValue = 0;
    let settingValueTxt = '';
    for (let i = 0; i < accountSettingType.length; i++) {

      let feature = accountSettingType[i];
      if (feature.flagName === settingName) {
        settingValue = feature.flagValue;
        settingValueTxt = feature.flagValueTxt;

      }
    }  

    this.setState({settingName: event.target.value, settingValue: settingValue, settingValueTxt: settingValueTxt});
  };


  render() {
    const { isAuthenticated, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;


    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedAppBind()) {

      const params = new URLSearchParams(this.props.location.search);
      let acctId = params.get('accountId');

   
      return (
        <Grid container spacing={3} direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            {acctId &&
            <PageTitle title="Account feature maintenance" subtitle="View or change an account feature setting" showBackButton={true} history={this.props.history}/>}
            {!acctId &&
            <PageTitle title="Account features" subtitle="Current settings of account features" showBackButton={true} history={this.props.history}/>}
          </Grid>
          <Grid item xs={12}>
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={FeatureFlagManageQuery}
              variables={{accountId : acctId, forceFetch: this.state.forceFetch}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {

                  let accountName = '';
                  if (props.allAccountTs.nodes.length !== 0) {
                    accountName = props.allAccountTs.nodes[0].accountName;
                  }

                  let features = props.query.base.nodes;
                  let flagType = [];
                  let flagTypeDropSet = new Set();
                  let flagTypeDropDown = [];
                  let settingType = [];
                  let settingTypeDropSet = new Set();
                  let settingTypeDropDown = [];

                  for (let i = 0; i < features.length; i++) {
                    let feature = features[i];
                    if (feature.flagType === 0) {
                      flagType.push(feature);
                      flagTypeDropSet.add(feature.flagName);
                    } else {
                      settingType.push(feature);
                      settingTypeDropSet.add(feature.flagName);

                    }
                  }  

                  let accountSpecificFeatures = [];
                  if (acctId) {
                    accountSpecificFeatures = props.query.account.nodes;
                  } 
                  let accountFlagType = [];
                  let accountSettingType = [];

                  for (let i = 0; i < accountSpecificFeatures.length; i++) {
                    let feature = accountSpecificFeatures[i];
                    if (feature.flagType === 0) {
                      accountFlagType.push(feature);
                      flagTypeDropSet.delete(feature.flagName);                
                    } else {

                      accountSettingType.push(feature);
                      settingTypeDropSet.delete(feature.flagName);
                    }
                  }  

                  flagTypeDropSet.forEach (function(value) {
                    if (value !== 'usePlaid') {
                      flagTypeDropDown.push(value);
                    }
                  });
                  settingTypeDropSet.forEach (function(value) {
                    settingTypeDropDown.push(value);
                  })


                  return ( 
                    <Grid container spacing={3} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="flex-start">
                            <Grid item xs={12}>
                              <Typography variant="h6">System flags for all accounts</Typography>
                            </Grid>
                            <Grid  item xs={12}>
                              <Table>
                                  <TableHead style={AppBindStyles.tableHead}>
                                      <TableRow style={AppBindStyles.tableHeadRow}>
                                          <TableCell>Name</TableCell>
                                          <TableCell>Description</TableCell>
                                          <TableCell>On/Off</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {flagType.map(feature => {

                                        let onIndicator = "On";
                                        if (feature.flagValue === 0) {
                                          onIndicator = "Off";
                                        }
                                          return (
                                              <TableRow key={feature.accountFeatureId}>
                                                  <TableCell align="left">{feature.flagName}</TableCell>
                                                  <TableCell align="left">{feature.flagDescription}</TableCell>
                                                  <TableCell align="left">{onIndicator}</TableCell>
                                              </TableRow>
                                          );
                                      })}
                                  </TableBody>
                              </Table>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>

                      {acctId &&

                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="flex-start">
                            <Grid item xs={12}>
                              <Typography variant="h6">{'Flags overridden for ' + accountName }</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Table>
                                  <TableHead style={AppBindStyles.tableHead}>
                                      <TableRow style={AppBindStyles.tableHeadRow}>
                                          <TableCell>Name</TableCell>
                                          <TableCell>On/Off</TableCell>
                                          <TableCell></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {accountFlagType.map(feature => {

                                        let onIndicator = "On";
                                        if (feature.flagValue === 0) {
                                          onIndicator = "Off";
                                        }
                                        let accountFeatureId = feature.accountFeatureId;
                                        return (
                                            <TableRow key={feature.accountFeatureId}>
                                                <TableCell align="left">{feature.flagName}</TableCell>
                                                <TableCell align="left">{onIndicator}</TableCell>
                                                <TableCell align="left">
                                                  <Button style={{marginTop: '12px'}} color="primary" 
                                                    variant="outlined" 
                                                    onClick={() => { this.removeOverride(accountFeatureId); }}>Remove override</Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                      })}
                                  </TableBody>
                              </Table>
                            </Grid>
                            <Grid item xs={3}>
                              <FormControl variant="standard" className={classes.select}>
                                <InputLabel shrink htmlFor="flag-name">Name</InputLabel>
                                <Select
                                  value={this.state.flagName}
                                  onChange={ (e) => this.handleFlagNameChange(e, flagType) }
                                  inputProps={{
                                    name: 'flag-name',
                                    id: 'flag-name'
                                  }}
                                  displayEmpty
                                >

                                  {flagTypeDropDown.map(n => {
                                      return(<MenuItem key={n} value={n}>{n}</MenuItem>);
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                  id="flagValue" label="On/off" className={classes.textField}
                                  value={ this.state.flagValue }
                                  onChange={ (e) => this.setState({ flagValue: e.target.value }) }
                                />
                            </Grid>
                            <Grid item>
                              <Button style={{marginTop: '12px'}} color="primary" 
                                disabled={this.state.flagName === ''} 
                                variant="outlined" 
                                onClick={() => { this.addOverride(acctId, 0, this.state.flagName, parseInt(this.state.flagValue), this.state.flagValueTxt.toString()); }}>Add override</Button>
                            </Grid>

                          </Grid>
                        </Paper>
                      </Grid>
                      }

                      <Grid item  xs={12}>
                        <Paper className={classes.paper}>
                        <Grid container spacing={2} direction="row" justifyContent="flex-start">
                            <Grid item xs={12}>
                              <Typography variant="h6">System defaults</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Table>
                                  <TableHead style={AppBindStyles.tableHead}>
                                      <TableRow style={AppBindStyles.tableHeadRow}>
                                          <TableCell>Name</TableCell>
                                          <TableCell>Description</TableCell>
                                          <TableCell>On/off</TableCell>
                                          <TableCell>Default value</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {settingType.map(feature => {

                                          let onIndicator = "On";
                                          if (feature.flagValue === 0) {
                                            onIndicator = "Off";
                                          }

                                          return (
                                              <TableRow key={feature.accountFeatureId}>
                                                  <TableCell align="left">{feature.flagName}</TableCell>
                                                  <TableCell align="left">{feature.flagDescription}</TableCell>
                                                  <TableCell align="left">{onIndicator}</TableCell>
                                                  <TableCell align="left">{feature.flagValueTxt}</TableCell>
                                              </TableRow>
                                          );
                                      })}
                                  </TableBody>
                              </Table>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>

                      {acctId &&
                      <Grid item  xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="flex-start">
                            <Grid item xs={12}>
                              <Typography variant="h6">{'System defaults overridden for ' + accountName}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Table>
                                  <TableHead style={AppBindStyles.tableHead}>
                                      <TableRow style={AppBindStyles.tableHeadRow}>
                                          <TableCell>Name</TableCell>
                                          <TableCell>On/off</TableCell>
                                          <TableCell>Default value</TableCell>
                                          <TableCell></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {accountSettingType.map(feature => {


                                          let onIndicator = "On";
                                          if (feature.flagValue === 0) {
                                            onIndicator = "Off";
                                          }
                                          let accountFeatureId = feature.accountFeatureId;
                                          return (
                                              <TableRow key={feature.accountFeatureId}>
                                                  <TableCell align="left">{feature.flagName}</TableCell>
                                                  <TableCell align="left">{onIndicator}</TableCell>
                                                  <TableCell align="left">{feature.flagValueTxt}</TableCell>
                                                  <TableCell align="left">
                                                    <Button style={{marginTop: '12px'}} color="primary" 
                                                      variant="outlined" 
                                                      onClick={() => { this.removeOverride(accountFeatureId); }}>Remove override</Button>
                                                  </TableCell>
                                              </TableRow>
                                          );
                                      })}
                                  </TableBody>
                              </Table>
                            </Grid>
                            <Grid item xs={3}>
                              <FormControl variant="standard" className={classes.select}>
                                <InputLabel shrink htmlFor="setting-name">Name</InputLabel>
                                <Select
                                  value={this.state.settingName}
                                  onChange={ (e) => this.handleDefaultFlagNameChange(e, settingType) }
                                  inputProps={{
                                    name: 'setting-name',
                                    id: 'setting-name'
                                  }}
                                  displayEmpty
                                >

                                  {settingTypeDropDown.map(n => {
                                      return(<MenuItem key={n} value={n}>{n}</MenuItem>);
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                  id="flagValue" label="On/off" className={classes.textField}
                                  value={ this.state.settingValue }
                                  onChange={ (e) => this.setState({ settingValue: e.target.value }) }
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                  id="flagValueTxt" label="Default value" className={classes.textField}
                                  value={ this.state.settingValueTxt }
                                  onChange={ (e) => this.setState({ settingValueTxt: e.target.value }) }
                                />
                            </Grid>
                            <Grid item>
                              <Button style={{marginTop: '12px'}} color="primary" 
                                disabled={this.state.settingName === ''} 
                                variant="outlined" 
                                onClick={() => { this.addOverride(acctId, 1, this.state.settingName, parseInt(this.state.settingValue), this.state.settingValueTxt.toString()); }}>Add override</Button>
                            </Grid>

                          </Grid>
                        </Paper>
                      </Grid>
                      }
                    </Grid>


                  )
                }
                return (
                  <div>
                    <Typography>Loading...</Typography>
                    <LoadingSpinner/>
                  </div>
                );
              }}
            />
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  addOverride(accountId, type, name, value, valueTxt) {

    FeatureFlagCreateMutation.commit(accountId, type, name, parseInt(value), valueTxt.toString())
    .then(response => {
      let forceFetch = this.state.forceFetch;
      forceFetch++;
      this.setState({forceFetch: forceFetch, flagName: '', flagValue: '', flagValueText: '', settingName: '', settingValue: '', settingValueText: ''});
    })
    .catch(error => {
      console.log('Got error: ' + error);
      //this.setState({forceFetch: forceFetch, flagName: '', flagValue: '', flagValueText: ''});
    });
  } 

  removeOverride(accountFeatureId) {

    FeatureFlagDeleteMutation.commit(accountFeatureId)
    .then(response => {
      let forceFetch = this.state.forceFetch;
      forceFetch++;
      this.setState({forceFetch: forceFetch, flagName: '', flagValue: '', flagValueText: ''});
    })
    .catch(error => {
      //console.log('Got error: ' + error);
      //this.setState({forceFetch: forceFetch, flagName: '', flagValue: '', flagValueText: ''});
    });
 
  
  } 
}

FeatureFlagManage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(FeatureFlagManage);
